// extracted by mini-css-extract-plugin
module.exports = {"main":"MainLayout_main__3VPOe","navbar":"MainLayout_navbar__29L9H"};